import { useToggle } from '@mews/framework';
import { ExpandableBox } from '@optimus-web/helpers';
import { ClickableDiv, ExpandIcon, Stack } from '@optimus-web/core';

interface Props {
    label: React.ReactNode;
    additionalInfo?: React.ReactNode;
    iconPosition?: 'left' | 'right';
}

const TogglableList: React.FC<React.PropsWithChildren<Props>> = ({
    label,
    additionalInfo,
    children,
    iconPosition = 'left',
}) => {
    const [isToggled, toggle] = useToggle();
    const icon = <ExpandIcon size="small" expanded={isToggled} />;
    return (
        <>
            <ClickableDiv onClick={toggle}>
                <Stack distribution="space-between" itemAlignment="center">
                    <Stack distribution="space-between" itemAlignment="center" spacing="100">
                        {iconPosition === 'left' && icon}
                        {label}
                        {iconPosition === 'right' && icon}
                    </Stack>
                    {additionalInfo}
                </Stack>
            </ClickableDiv>
            <ExpandableBox expanded={isToggled}>{children}</ExpandableBox>
        </>
    );
};

export default TogglableList;
